import {clearAddDistrictAlert} from "../../actions/districts";
import Alert from "../common/alert";
import SelectDistrict from "../selectDistrict";
import React from "react";
import {useDispatch, useSelector} from "react-redux";

const SelectDistrictForm = (props) => {
  const {
    canAddDistrict
  } = props;

  const addDistrictAlert = useSelector((state) => state.districts.addDistrictAlert);
  const dispatch = useDispatch();

  const onDismissAlert = () => {
    dispatch(clearAddDistrictAlert());
  }

  return (
    <div className='select-district-form'>
      {canAddDistrict ?
        <div className='add-district-button-container'>
        <a href='/#/add-district'><button className='tes-button sr-hide' onClick={(e) => dispatch(clearAddDistrictAlert())}>+ New District</button></a>
      </div> : ''}
      <div className='select-district-alerts'>
        {(addDistrictAlert) && <Alert onDismiss={onDismissAlert} messageType='success'>{addDistrictAlert}</Alert>}
      </div>
      <div className='switch-districts-header'>Select a District</div>
      <div className='select-district-container'>
        <SelectDistrict/>
      </div>

    </div>
  );
}

export default SelectDistrictForm;